import React from 'react'
import { Heading, Text } from '@primer/react-brand'
import Eyebrow from './Eyebrow'

// Every section opens the same way: eyebrow, heading, one short lede, all
// left-aligned and capped at a readable measure. Centered intros were what made
// the previous page read as a template; a consistent left edge makes it read as
// one document.
const SectionHeader = ({ eyebrow, heading, lede, as = 'h2', size = '3' }) => (
  <div style={{ maxWidth: '720px' }}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <Heading
      as={as}
      size={size}
      weight="semibold"
      style={{ marginTop: eyebrow ? '12px' : 0, textWrap: 'balance' }}
    >
      {heading}
    </Heading>
    {lede && (
      <Text as="p" size="300" variant="muted" style={{ marginTop: '16px', marginBottom: 0, maxWidth: '640px' }}>
        {lede}
      </Text>
    )}
  </div>
)

export default SectionHeader
